import type { ValidDate } from '@blk/awt-aladdinwealthserver';
import { getQueryClient } from '../../queryClient';
import { workflowDatesQuery } from '../queries';

/**
 * Fetch workflow dates with TanStack Query caching.
 * Returns the data array directly.
 */
export function getWorkflowDates(): Promise<ValidDate[]> {
  const queryClient = getQueryClient();
  return queryClient.fetchQuery(workflowDatesQuery);
}
